import React from 'react';
import PropTypes from 'prop-types';
import DeltaWifiFeaturedVenueCard from './DeltaWifiFeaturedVenueCard';
import './DeltaWifiFeaturedVenues.scss';
import { postFinderList } from '../../../../../../ui-kitchen/src/api/api';
import { finder4Transform } from '../../../../../../ui-kitchen/src/api/resyApiTransformer';
import { ALL_DAY } from '../../../../../../ui-kitchen/src/constants/resyCore';

class DeltaWifiFeaturedVenues extends React.Component {
  state = {
    restaurants: [],
  }

  componentDidMount() {
    this.getVenueDetails();
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps) {
    const {
      selectedDate, selectedSeats, selectedTime,
    } = this.props;
    if (prevProps.selectedDate !== selectedDate
      || prevProps.selectedSeats !== selectedSeats
      || prevProps.selectedTime !== selectedTime) {
      this.getVenueDetails();
    }
  }

  getVenueDetails = async () => {
    const {
      selectedDate, selectedSeats, featuredVenuesConfigData, selectedTime,
    } = this.props;

    const { venue_ids: venueIds } = featuredVenuesConfigData;

    const params = {
      lat: 0,
      long: 0,
      day: selectedDate,
      party_size: selectedSeats,
      venue_id: venueIds,
      resy_token: undefined,
      time_filter: selectedTime === ALL_DAY ? undefined : moment(selectedTime, 'HHmm').format('HH:mm'),
    };

    const response = await postFinderList(params);
    const apiResponse = finder4Transform(response);
    const venueResponseList = apiResponse?.results.venues;

    if (venueResponseList) {
      const displayVenueResponseList = this.displayFeaturedVenues(venueResponseList);
      const restaurants = displayVenueResponseList.map((item) => {
        const {
          venue: {
            name, currency, priceRange, cuisine, images, urlSlug, location: {
              name: locationName, urlSlug: locationSlug,
            },
          },
        } = item;
        const range = this.buildPrice(currency, priceRange);
        const newItem = {
          name,
          cuisine,
          range,
          locationName,
          image: images ? images[0] : '',
          bookNowLink: `/cities/${locationSlug}/venues/${urlSlug}`,
        };

        return newItem;
      });
      this.setState({ restaurants });
    }
  };

   displayFeaturedVenues = (restaurants) => {
     const len = restaurants.length;

     if (len === 5 || len === 10 || len === 15) {
       return restaurants;
     }

     if (len < 10 && len > 5) {
       restaurants = restaurants.slice(0, 5);
     } else if (len < 15 && len > 10) {
       restaurants = restaurants.slice(0, 10);
     } else if (len > 15) {
       restaurants = restaurants.slice(0, 15);
     } else if (len < 5) {
       restaurants = [];
     }
     return restaurants;
   }

   buildPrice = (currency, priceRange) => {
     let price = '';
     const symbol = currency || '$';

     for (let i = 0; i < priceRange; i += 1) {
       price += symbol;
     }
     return price;
   };

   render() {
     const { restaurants } = this.state;
     const { analyticsEvent } = this.props;
     const {
       featuredVenuesConfigData: {
         heading, subHeading_1: subHeading1, subHeading_2: subHeading2, bookNowLabel,
       },
     } = this.props;

     if (!restaurants || restaurants.length === 0) {
       return null;
     }

     return (
       <section className="DeltaWifiFeaturedVenues DeltaWifiFeaturedVenues__section">
         <div className="container">
           <h2>{heading}</h2>
           <p className="DeltaWifiFeaturedVenues__Text DeltaWifiFeaturedVenues__Text--desktop">
             {subHeading1}
             <br />
             {subHeading2}
           </p>
           <p className="DeltaWifiFeaturedVenues__Text DeltaWifiFeaturedVenues__Text--mobile">
             {subHeading1}
             {subHeading2}
           </p>
           <div className="DeltaWifiFeaturedVenues__Wrap">
             <div className="DeltaWifiFeaturedVenues__Grid">
               {restaurants.map((restaurant) => (
                 <DeltaWifiFeaturedVenueCard
                   key={`${restaurant.name}${restaurant.cuisine}`}
                   restaurant={restaurant}
                   bookNowLinkText={bookNowLabel}
                   analyticsEvent={analyticsEvent}
                 />
               ))}
             </div>
           </div>
         </div>
       </section>
     );
   }
}

DeltaWifiFeaturedVenues.propTypes = {
  selectedDate: PropTypes.string.isRequired,
  selectedSeats: PropTypes.string.isRequired,
  selectedTime: PropTypes.string.isRequired,
  featuredVenuesConfigData: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    subHeading_1: PropTypes.string.isRequired,
    subHeading_2: PropTypes.string.isRequired,
    venue_ids: PropTypes.string.isRequired,
    bookNowLabel: PropTypes.string.isRequired,
  }).isRequired,
  analyticsEvent: PropTypes.func.isRequired,
};

export default DeltaWifiFeaturedVenues;
